// extracted by mini-css-extract-plugin
module.exports = {"installmentsTitle":"_3pwrk","dropdownWrapper":"_2863p"};